import { useSharedLogging } from './LoggingProvider';
import { LoggingContext } from './types';

export function useSharedLoggingWithContext(
  defaultContext?: LoggingContext
) {
  const logger = useSharedLogging();

  const mergeContext = (additionalContext?: LoggingContext) => ({
    tags: { ...defaultContext?.tags, ...additionalContext?.tags },
    contexts: { ...defaultContext?.contexts, ...additionalContext?.contexts },
    level: additionalContext?.level ?? defaultContext?.level,
  });

  const logDebug = (message: string, additionalContext?: LoggingContext) => {
    logger.logDebug(message, mergeContext(additionalContext));
  };

  const logInfo = (message: string, additionalContext?: LoggingContext) => {
    logger.logInfo(message, mergeContext(additionalContext));
  };

  const logWarn = (message: string, additionalContext?: LoggingContext) => {
    logger.logWarn(message, mergeContext(additionalContext));
  };

  const logException = (error: Error, additionalContext?: LoggingContext) => {
    logger.logException(error, mergeContext(additionalContext));
  };

  return {
    logDebug,
    logInfo,
    logWarn,
    logException,
  };
} 